import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const studioUrbanBeach: Collection = {
  id: 'sp-studio-urban-beach',
  brandId: 'sp',
  brandName: 'S|P Collection',
  icon: 'sp-collection.png',
  title: 'Studio Urban Beach',
  subTitle: 'Tijdloos',
  banner: 'studio-urban-beach/studio-urban-beach-banner.jpg',
  items: [
    {
      id: 'sp-studio-urban-beach-1',
      collectionImages: [
        {
          image: 'studio-urban-beach/Studio Urban Beach_6.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'studio-urban-beach/Studio Urban Beach_1.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'studio-urban-beach/Studio Urban Beach_11.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'sp-studio-urban-beach-2',
      collectionImages: [
        {
          image: 'studio-urban-beach/Studio Urban Beach_17.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'studio-urban-beach/Studio Urban Beach_26.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'studio-urban-beach/Studio Urban Beach_28.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '9f25968a-f6a8-43f1-9b7c-16005a07a813',
    '20c3aa2e-a5bd-49eb-9de4-e7526b79171f',
    'bbbc99be-c982-4778-bc38-489fb8d93af6',
    'e4f2cd0e-0afc-49c9-b57a-8ca489c8f3cf',
    '9f5ea487-9502-4b0d-a607-bb9fca1a6e05',
    '9d464bab-b21b-454e-a110-3517f082be89',
    'b516b003-d430-47e1-9cf6-7c9f346f7c24',
    'a5ac3c5d-c2e2-412e-87e9-bfddc30f5ff0',
    'a1523554-2296-4aa5-98e7-8e1f67a90b53',
    '3c782e52-3b3a-4cd0-8f5d-688f25126516',
    '557817ae-9d51-407e-a982-2c879f5f9520'
  ]
};
